<template>
  <div v-loading="loading">
    <div v-if="query3 != ''">
      <el-button type="warning" plain @click="dkbg1()">重新生成该报告</el-button>
      <div>报告编号{{ resp_order }}</div>
      <div class="sad">行为贷款信息--<span class="zhuangtai">状态：{{ resp_code }}</span></div>
      <div class="diyige">
        <table border="1" class="biaoge">
          <tr>
            <th>贷款行为分</th>
            <th>正常还款订单数占贷款总订单数比例</th>
            <th>最近一次履约距今天数</th>
            <th>贷款行为置信度</th>
            <th>贷款已结清订单数</th>
            <th>信用贷款时长</th>
            <th>最近一次贷款放款时间</th>
          </tr>
          <tr>
            <th>{{ B22170001 }}</th>
            <th>{{ B22170034 }}</th>
            <th>{{ B22170050 }}</th>
            <th>{{ B22170051 }}</th>
            <th>{{ B22170052 }}</th>
            <th>{{ B22170053 }}</th>
            <th>{{ B22170054 }}</th>
          </tr>
        </table>
      </div>
      <div class="diyige">
        <table border="1" class="biaoge">
          <tr>
            <th>字段</th>
            <th>贷款金额在1k及以下的笔数</th>
            <th>贷款金额在1k-3k的笔数</th>
            <th>贷款金额在3k-10k的笔数</th>
            <th>贷款金额在1w以上的笔数</th>
          </tr>
          <tr>
            <th>近12月</th>
            <th>{{ B22170012 }}</th>
            <th>{{ B22170013 }}</th>
            <th>{{ B22170014 }}</th>
            <th>{{ B22170015 }}</th>
          </tr>
        </table>
      </div>
      <div class="diyige">
        <table border="1" class="biaoge">
          <tr>
            <th>字段</th>
            <th>近1个月</th>
            <th>近3个月</th>
            <th>近6个月</th>
            <th>近12个月</th>
            <th>近24个月</th>
          </tr>
          <tr>
            <th>贷款笔数</th>
            <th>{{ B22170002 }}</th>
            <th>{{ B22170003 }}</th>
            <th>{{ B22170004 }}</th>
            <th>{{ B22170005 }}</th>
            <th>{{ B22170006 }}</th>
          </tr>
          <tr>
            <th>贷款总金额</th>
            <th>{{ B22170007 }}</th>
            <th>{{ B22170008 }}</th>
            <th>{{ B22170009 }}</th>
            <th>{{ B22170010 }}</th>
            <th>{{ B22170011 }}</th>
          </tr>
          <tr>
            <th>贷款机构数</th>
            <th>{{ B22170016 }}</th>
            <th>{{ B22170017 }}</th>
            <th>{{ B22170018 }}</th>
            <th>{{ B22170019 }}</th>
            <th>{{ B22170020 }}</th>
          </tr>
          <tr>
            <th>消金类贷款机构数</th>
            <th>无字段</th>
            <th>无字段</th>
            <th>无字段</th>
            <th>{{ B22170021 }}</th>
            <th>{{ B22170022 }}</th>
          </tr>
          <tr>
            <th>网贷类贷款机构数</th>
            <th>无字段</th>
            <th>无字段</th>
            <th>无字段</th>
            <th>{{ B22170023 }}</th>
            <th>{{ B22170024 }}</th>
          </tr>
          <tr>
            <th>M0+逾期贷款笔数 / M1+逾期贷款笔数</th>
            <th>无字段</th>
            <th>无字段</th>
            <th>{{ B22170025 }}/{{ B22170028 }}</th>
            <th>{{ B22170026 }}/{{ B22170029 }}</th>
            <th>{{ B22170027 }}/{{ B22170030 }}</th>
          </tr>
          <tr>
            <th>失败扣款笔数</th>
            <th>{{ B22170035 }}</th>
            <th>{{ B22170036 }}</th>
            <th>{{ B22170037 }}</th>
            <th>{{ B22170038 }}</th>
            <th>{{ B22170039 }}</th>
          </tr>
          <tr>
            <th>履约贷款总金额</th>
            <th>{{ B22170040 }}</th>
            <th>{{ B22170041 }}</th>
            <th>{{ B22170042 }}</th>
            <th>{{ B22170043 }}</th>
            <th>{{ B22170044 }}</th>
          </tr>
          <tr>
            <th>履约贷款次数</th>
            <th>{{ B22170045 }}</th>
            <th>{{ B22170046 }}</th>
            <th>{{ B22170047 }}</th>
            <th>{{ B22170048 }}</th>
            <th>{{ B22170049 }}</th>
          </tr>
        </table>
      </div>

      <div class="diyige">
        <table border="1" class="biaoge">
          <tr>
            <th>贷款行为分:{{ B22170001 }}</th>
            <th>近1个月贷款笔数:{{ B22170002 }}</th>
            <th>近3个月贷款笔数:{{ B22170003 }}</th>
            <th>近6个月贷款笔数:{{ B22170004 }}</th>
          </tr>
          <tr>
            <th>近12个月贷款笔数:{{ B22170005 }}</th>
            <th>近24个月贷款笔数:{{ B22170006 }}</th>
            <th>近1个月贷款总金额:{{ B22170007 }}</th>
            <th>近3个月贷款总金额:{{ B22170008 }}</th>
          </tr>
          <tr>
            <th>近6个月贷款总金额:{{ B22170009 }}</th>
            <th>近12个月贷款总金额:{{ B22170010 }}</th>
            <th>近24个月贷款总金额:{{ B22170011 }}</th>
            <th>近12个月贷款金额在1k及以下的笔数:{{ B22170012 }}</th>
          </tr>
          <tr>
            <th>近12个月贷款金额在1k-3k的笔数:{{ B22170013 }}</th>
            <th>近12个月贷款金额在3k-10k的笔数:{{ B22170014 }}</th>
            <th>近12个月贷款金额在1w以上的笔数:{{ B22170015 }}</th>
            <th>近1个月贷款机构数:{{ B22170016 }}</th>
          </tr>
          <tr>
            <th>近3个月贷款机构数:{{ B22170017 }}</th>
            <th>近6个月贷款机构数:{{ B22170018 }}</th>
            <th>近12个月贷款机构数:{{ B22170019 }}</th>
            <th>近24个月贷款机构数:{{ B22170020 }}</th>
          </tr>
          <tr>
            <th>近12个月消金类贷款机构数:{{ B22170021 }}</th>
            <th>近24个月消金类贷款机构数:{{ B22170022 }}</th>
            <th>近12个月网贷类贷款机构数:{{ B22170023 }}</th>
            <th>近24个月网贷类贷款机构数:{{ B22170024 }}</th>
          </tr>
          <tr>
            <th>近6个月M0+逾期贷款笔数:{{ B22170025 }}</th>
            <th>近12个月M0+逾期贷款笔数:{{ B22170026 }}</th>
            <th>近24个月M0+逾期贷款笔数:{{ B22170027 }}</th>
            <th>近6个月M1+逾期贷款笔数:{{ B22170028 }}</th>
          </tr>
          <tr>
            <th>近12个月M1+逾期贷款笔数:{{ B22170029 }}</th>
            <th>近24个月M1+逾期贷款笔数:{{ B22170030 }}</th>
            <th>近6个月累计逾期金额:{{ B22170031 }}</th>
            <th>近12个月累计逾期金额:{{ B22170032 }}</th>
          </tr>
          <tr>
            <th>近24个月累计逾期金额:{{ B22170033 }}</th>
            <th>正常还款订单数占贷款总订单数比例:{{ B22170034 }}</th>
            <th>近1个月失败扣款笔数:{{ B22170035 }}</th>
            <th>近3个月失败扣款笔数:{{ B22170036 }}</th>
          </tr>
          <tr>
            <th>近6个月失败扣款笔数:{{ B22170037 }}</th>
            <th>近12个月失败扣款笔数:{{ B22170038 }}</th>
            <th>近24个月失败扣款笔数:{{ B22170039 }}</th>
            <th>近1个月履约贷款总金额:{{ B22170040 }}</th>
          </tr>
          <tr>
            <th>近3个月履约贷款总金额:{{ B22170041 }}</th>
            <th>近6个月履约贷款总金额:{{ B22170042 }}</th>
            <th>近12个月履约贷款总金额:{{ B22170043 }}</th>
            <th>近24个月履约贷款总金额:{{ B22170044 }}</th>
          </tr>
          <tr>
            <th>近1个月履约贷款次数:{{ B22170045 }}</th>
            <th>近3个月履约贷款次数:{{ B22170046 }}</th>
            <th>近6个月履约贷款次数:{{ B22170047 }}</th>
            <th>近12个月履约贷款次数:{{ B22170048 }}</th>
          </tr>
          <tr>
            <th>近24个月履约贷款次数:{{ B22170049 }}</th>
            <th>最近一次履约距今天数:{{ B22170050 }}</th>
            <th>贷款行为置信度:{{ B22170051 }}</th>
            <th>贷款已结清订单数:{{ B22170052 }}</th>
          </tr>
          <tr>
            <th>信用贷款时长:{{ B22170053 }}</th>
            <th>最近一次贷款放款时间:{{ B22170054 }}</th>
            <th></th>
            <th></th>
          </tr>
        </table>

      </div>
    </div>
    <div v-else class="bgelse">
      <div class="tishi">提示：请生成报告后再查看该报告！</div>
      <div class="baogao">贷款报告没有生成</div>
      <div class="shhengcheng">
        <el-button type="warning" plain @click="dkbg1()">生成该报告</el-button>
      </div>
    </div>
  </div>
</template>
  
<script>
import FengkongApi from "@/api/fengkong.js";
import Table from "../../product/product/part/spec/many/Table.vue";
export default {
  components: { Table },
  props: ["order_id", "query3"],
  data() {
    return {
      loading: false,
      resp_order: "",
      resp_code: "",
      B22170001: "",
      B22170034: "",
      B22170050: "",
      B22170051: "",
      B22170052: "",
      B22170053: "",
      B22170054: "",
      B22170012: "",
      B22170013: "",
      B22170014: "",
      B22170015: "",
      B22170002: "",
      B22170003: "",
      B22170004: "",
      B22170005: "",
      B22170006: "",
      B22170007: "",
      B22170008: "",
      B22170009: "",
      B22170010: "",
      B22170011: "",
      B22170016: "",
      B22170017: "",
      B22170018: "",
      B22170019: "",
      B22170020: "",
      B22170021: "",
      B22170022: "",
      B22170023: "",
      B22170024: "",
      B22170025: "",
      B22170026: "",
      B22170027: "",
      B22170035: "",
      B22170036: "",
      B22170037: "",
      B22170038: "",
      B22170039: "",
      B22170040: "",
      B22170041: "",
      B22170042: "",
      B22170043: "",
      B22170044: "",
      B22170045: "",
      B22170046: "",
      B22170047: "",
      B22170048: "",
      B22170049: "",
      B22170028: "",
      B22170029: "",
      B22170030: "",
      B22170031: "",
      B22170032: "",
      B22170033: "",
      B22170034: "",
    };
  },
  created() {
    let self = this;
    if (this.query3 != '') {
      // console.log("query3", this.query3);
      let dkbg = JSON.parse(this.query3);
      // console.log("贷款报告", dkbg);
      self.resp_order = dkbg.resp_order;
      self.resp_code = dkbg.resp_msg;
      self.B22170001 = dkbg.resp_data.behavior_report_detail.B22170001;
      //贷款行为分
      self.B22170001 = dkbg.resp_data.behavior_report_detail.B22170001;
      //正常还款订单数占贷款总订单数比例
      self.B22170034 = dkbg.resp_data.behavior_report_detail.B22170034;
      //最近一次履约距今天数
      self.B22170050 = dkbg.resp_data.behavior_report_detail.B22170050;
      //贷款行为置信度
      self.B22170051 = dkbg.resp_data.behavior_report_detail.B22170051;
      //贷款已结清订单数
      self.B22170052 = dkbg.resp_data.behavior_report_detail.B22170052;
      //信用贷款时长
      self.B22170053 = dkbg.resp_data.behavior_report_detail.B22170053;
      //最近一次贷款放款时间
      self.B22170054 = dkbg.resp_data.behavior_report_detail.B22170054;
      //近12个月贷款金额在1k及以下的笔数
      self.B22170012 = dkbg.resp_data.behavior_report_detail.B22170012;
      //贷款金额在1k-3k的笔数
      self.B22170013 = dkbg.resp_data.behavior_report_detail.B22170013;
      //贷款金额在3k-10k的笔数
      self.B22170014 = dkbg.resp_data.behavior_report_detail.B22170014;
      //贷款金额在1w以上的笔数
      self.B22170015 = dkbg.resp_data.behavior_report_detail.B22170015;
      //近1个月贷款笔数
      self.B22170002 = dkbg.resp_data.behavior_report_detail.B22170002;
      //近3个月贷款笔数
      self.B22170003 = dkbg.resp_data.behavior_report_detail.B22170003;
      //近6个月贷款笔数
      self.B22170004 = dkbg.resp_data.behavior_report_detail.B22170004;
      //近12个月贷款笔数
      self.B22170005 = dkbg.resp_data.behavior_report_detail.B22170005;
      //近24个月贷款笔数
      self.B22170006 = dkbg.resp_data.behavior_report_detail.B22170006;
      //近1个月贷款总金额
      self.B22170007 = dkbg.resp_data.behavior_report_detail.B22170007;
      //近3个月贷款总金额
      self.B22170008 = dkbg.resp_data.behavior_report_detail.B22170008;
      //string	近6个月贷款总金额
      self.B22170009 = dkbg.resp_data.behavior_report_detail.B22170009;
      //近12个月贷款总金额
      self.B22170010 = dkbg.resp_data.behavior_report_detail.B22170010;
      //近24个月贷款总金额
      self.B22170011 = dkbg.resp_data.behavior_report_detail.B22170011;
      //近1个月贷款机构数
      self.B22170016 = dkbg.resp_data.behavior_report_detail.B22170016;
      //近3个月贷款机构数
      self.B22170017 = dkbg.resp_data.behavior_report_detail.B22170017;
      //近6个月贷款机构数
      self.B22170018 = dkbg.resp_data.behavior_report_detail.B22170018;
      //近12个月贷款机构数
      self.B22170019 = dkbg.resp_data.behavior_report_detail.B22170019;
      //近24个月贷款机构数
      self.B22170020 = dkbg.resp_data.behavior_report_detail.B22170020;
      //近12个月消金类贷款机构数
      self.B22170021 = dkbg.resp_data.behavior_report_detail.B22170021;
      //近24个月消金类贷款机构数
      self.B22170022 = dkbg.resp_data.behavior_report_detail.B22170022;
      //近12个月网贷类贷款机构数
      self.B22170023 = dkbg.resp_data.behavior_report_detail.B22170023;
      //近24个月网贷类贷款机构数
      self.B22170024 = dkbg.resp_data.behavior_report_detail.B22170024;
      //近6个月M0+逾期贷款笔数
      self.B22170025 = dkbg.resp_data.behavior_report_detail.B22170025;
      //近6个月M1+逾期贷款笔数
      self.B22170028 = dkbg.resp_data.behavior_report_detail.B22170028;
      //近12个月M0+逾期贷款笔数
      self.B22170026 = dkbg.resp_data.behavior_report_detail.B22170026;
      //近12个月M1+逾期贷款笔数
      self.B22170029 = dkbg.resp_data.behavior_report_detail.B22170029;
      //近24个月M0+逾期贷款笔数
      self.B22170027 = dkbg.resp_data.behavior_report_detail.B22170027;
      //近24个月M1+逾期贷款笔数
      self.B22170030 = dkbg.resp_data.behavior_report_detail.B22170030;
      //近1个月失败扣款笔数
      self.B22170035 = dkbg.resp_data.behavior_report_detail.B22170035;
      //近3个月失败扣款笔数
      self.B22170036 = dkbg.resp_data.behavior_report_detail.B22170036;
      //近6个月失败扣款笔数
      self.B22170037 = dkbg.resp_data.behavior_report_detail.B22170037;
      //近12个月失败扣款笔数
      self.B22170038 = dkbg.resp_data.behavior_report_detail.B22170038;
      //近24个月失败扣款笔数
      self.B22170039 = dkbg.resp_data.behavior_report_detail.B22170039;
      //近1个月履约贷款总金额
      self.B22170040 = dkbg.resp_data.behavior_report_detail.B22170040;
      //近3个月履约贷款总金额
      self.B22170041 = dkbg.resp_data.behavior_report_detail.B22170041;
      //近6个月履约贷款总金额
      self.B22170042 = dkbg.resp_data.behavior_report_detail.B22170042;
      //近12个月履约贷款总金额
      self.B22170043 = dkbg.resp_data.behavior_report_detail.B22170043;
      //近24个月履约贷款总金额
      self.B22170044 = dkbg.resp_data.behavior_report_detail.B22170044;
      //近1个月履约贷款次数
      self.B22170045 = dkbg.resp_data.behavior_report_detail.B22170045;
      //近3个月履约贷款次数
      self.B22170046 = dkbg.resp_data.behavior_report_detail.B22170046;
      //近6个月履约贷款次数
      self.B22170047 = dkbg.resp_data.behavior_report_detail.B22170047;
      //string	近12个月履约贷款次数
      self.B22170048 = dkbg.resp_data.behavior_report_detail.B22170048;
      //近24个月履约贷款次数
      self.B22170049 = dkbg.resp_data.behavior_report_detail.B22170049;
      //近6个月累计逾期金额
      self.B22170031 = dkbg.resp_data.behavior_report_detail.B22170031;
      //近12个月累计逾期金额
      self.B22170032 = dkbg.resp_data.behavior_report_detail.B22170032;
      //近24个月累计逾期金额
      self.B22170033 = dkbg.resp_data.behavior_report_detail.B22170033;
      //正常还款订单数占贷款总订单数比例
      self.B22170034 = dkbg.resp_data.behavior_report_detail.B22170034;
    }
  },

  methods: {
    dkbg1() {
      let self = this;
      self.loading = true;
      let Params = { orderid: self.order_id };
      FengkongApi.daikuan(Params, true)
        .then((data) => {
          // location.reload();
          // console.log(data,"data");
          self.query3 = 123;
          //报告编号
          self.resp_order = data.data.result.resp_order;
          //状态
          self.resp_code =  data.data.result.resp_msg;
          //贷款行为分
          self.B22170001 = data.data.result.resp_data.behavior_report_detail.B22170001;
          //正常还款订单数占贷款总订单数比例
          self.B22170034 = data.data.result.resp_data.behavior_report_detail.B22170034;
          //最近一次履约距今天数
          self.B22170050 = data.data.result.resp_data.behavior_report_detail.B22170050;
          //贷款行为置信度
          self.B22170051 = data.data.result.resp_data.behavior_report_detail.B22170051;
          //贷款已结清订单数
          self.B22170052 = data.data.result.resp_data.behavior_report_detail.B22170052;
          //信用贷款时长
          self.B22170053 = data.data.result.resp_data.behavior_report_detail.B22170053;
          //最近一次贷款放款时间
          self.B22170054 = data.data.result.resp_data.behavior_report_detail.B22170054;
          //近12个月贷款金额在1k及以下的笔数
          self.B22170012 = data.data.result.resp_data.behavior_report_detail.B22170012;
          //贷款金额在1k-3k的笔数
          self.B22170013 = data.data.result.resp_data.behavior_report_detail.B22170013;
          //贷款金额在3k-10k的笔数
          self.B22170014 = data.data.result.resp_data.behavior_report_detail.B22170014;
          //贷款金额在1w以上的笔数
          self.B22170015 = data.data.result.resp_data.behavior_report_detail.B22170015;
          //近1个月贷款笔数
          self.B22170002 = data.data.result.resp_data.behavior_report_detail.B22170002;
          //近3个月贷款笔数
          self.B22170003 = data.data.result.resp_data.behavior_report_detail.B22170003;
          //近6个月贷款笔数
          self.B22170004 = data.data.result.resp_data.behavior_report_detail.B22170004;
          //近12个月贷款笔数
          self.B22170005 = data.data.result.resp_data.behavior_report_detail.B22170005;
          //近24个月贷款笔数
          self.B22170006 = data.data.result.resp_data.behavior_report_detail.B22170006;
          //近1个月贷款总金额
          self.B22170007 = data.data.result.resp_data.behavior_report_detail.B22170007;
          //近3个月贷款总金额
          self.B22170008 = data.data.result.resp_data.behavior_report_detail.B22170008;
          //string	近6个月贷款总金额
          self.B22170009 = data.data.result.resp_data.behavior_report_detail.B22170009;
          //近12个月贷款总金额
          self.B22170010 = data.data.result.resp_data.behavior_report_detail.B22170010;
          //近24个月贷款总金额
          self.B22170011 = data.data.result.resp_data.behavior_report_detail.B22170011;
          //近1个月贷款机构数
          self.B22170016 = data.data.result.resp_data.behavior_report_detail.B22170016;
          //近3个月贷款机构数
          self.B22170017 = data.data.result.resp_data.behavior_report_detail.B22170017;
          //近6个月贷款机构数
          self.B22170018 = data.data.result.resp_data.behavior_report_detail.B22170018;
          //近12个月贷款机构数
          self.B22170019 = data.data.result.resp_data.behavior_report_detail.B22170019;
          //近24个月贷款机构数
          self.B22170020 = data.data.result.resp_data.behavior_report_detail.B22170020;
          //近12个月消金类贷款机构数
          self.B22170021 = data.data.result.resp_data.behavior_report_detail.B22170021;
          //近24个月消金类贷款机构数
          self.B22170022 = data.data.result.resp_data.behavior_report_detail.B22170022;
          //近12个月网贷类贷款机构数
          self.B22170023 = data.data.result.resp_data.behavior_report_detail.B22170023;
          //近24个月网贷类贷款机构数
          self.B22170024 = data.data.result.resp_data.behavior_report_detail.B22170024;
          //近6个月M0+逾期贷款笔数
          self.B22170025 = data.data.result.resp_data.behavior_report_detail.B22170025;
          //近6个月M1+逾期贷款笔数
          self.B22170028 = data.data.result.resp_data.behavior_report_detail.B22170028;
          //近12个月M0+逾期贷款笔数
          self.B22170026 = data.data.result.resp_data.behavior_report_detail.B22170026;
          //近12个月M1+逾期贷款笔数
          self.B22170029 = data.data.result.resp_data.behavior_report_detail.B22170029;
          //近24个月M0+逾期贷款笔数
          self.B22170027 = data.data.result.resp_data.behavior_report_detail.B22170027;
          //近24个月M1+逾期贷款笔数
          self.B22170030 = data.data.result.resp_data.behavior_report_detail.B22170030;
          //近1个月失败扣款笔数
          self.B22170035 = data.data.result.resp_data.behavior_report_detail.B22170035;
          //近3个月失败扣款笔数
          self.B22170036 = data.data.result.resp_data.behavior_report_detail.B22170036;
          //近6个月失败扣款笔数
          self.B22170037 = data.data.result.resp_data.behavior_report_detail.B22170037;
          //近12个月失败扣款笔数
          self.B22170038 = data.data.result.resp_data.behavior_report_detail.B22170038;
          //近24个月失败扣款笔数
          self.B22170039 = data.data.result.resp_data.behavior_report_detail.B22170039;
          //近1个月履约贷款总金额
          self.B22170040 = data.data.result.resp_data.behavior_report_detail.B22170040;
          //近3个月履约贷款总金额
          self.B22170041 = data.data.result.resp_data.behavior_report_detail.B22170041;
          //近6个月履约贷款总金额
          self.B22170042 = data.data.result.resp_data.behavior_report_detail.B22170042;
          //近12个月履约贷款总金额
          self.B22170043 = data.data.result.resp_data.behavior_report_detail.B22170043;
          //近24个月履约贷款总金额
          self.B22170044 = data.data.result.resp_data.behavior_report_detail.B22170044;
          //近1个月履约贷款次数
          self.B22170045 = data.data.result.resp_data.behavior_report_detail.B22170045;
          //近3个月履约贷款次数
          self.B22170046 = data.data.result.resp_data.behavior_report_detail.B22170046;
          //近6个月履约贷款次数
          self.B22170047 = data.data.result.resp_data.behavior_report_detail.B22170047;
          //string	近12个月履约贷款次数
          self.B22170048 = data.data.result.resp_data.behavior_report_detail.B22170048;
          //近24个月履约贷款次数
          self.B22170049 = data.data.result.resp_data.behavior_report_detail.B22170049;
          //近6个月累计逾期金额
          self.B22170031 = data.data.result.resp_data.behavior_report_detail.B22170031;
          //近12个月累计逾期金额
          self.B22170032 = data.data.result.resp_data.behavior_report_detail.B22170032;
          //近24个月累计逾期金额
          self.B22170033 = data.data.result.resp_data.behavior_report_detail.B22170033;
          //正常还款订单数占贷款总订单数比例
          self.B22170034 = data.data.result.resp_data.behavior_report_detail.B22170034;
          self.loading = false;
          self.$message({
            message: '加载完成',
            type: 'success'
          });
        })
        .catch((error) => { });
    }
  },
};
</script>
  
<style>

.biaoge {
  border-collapse: collapse;
  width: 100%;
}

.zhuangtai {
  color: #1890ff;
  font-size: 20px;


}

.sad {
  font-size: 20px;
  display: flex;
  justify-content: center;
}

.diyige {
  margin-top: 50px;
}
</style>
  


// WEBPACK FOOTER //
// src/views/fengkong/operation/detail5.vue